module.exports = __webpack_public_path__ + "static/media/swing-woman.24748046.svg";